import { createContext, useContext, useEffect, useState } from "react";

export const LOGOS = {
  en: "https://customer-assets-v7afamib.emergentagent.net/job_dda150cc-0e0f-47cb-ac5b-c75778b571cf/artifacts/zfxjuyh3_CODE%20ECHO%20LOGO.png",
  fr: "https://customer-assets-m6fa6gv7.emergentagent.net/job_code-echo-deploy/artifacts/pf2nrpnz_Code%20echo%20french.png",
};

export const TRANSLATIONS = {
  en: {
    // Nav
    nav_links: [
      { label: "Our Mandate", id: "manifesto" },
      { label: "What We Deliver", id: "logistics" },
      { label: "Where We've Been", id: "map" },
      { label: "Join Our Mission", id: "join" },
    ],
    nav_cta: "Request Deployment",

    // Hero
    hero_badge: "Non-Profit Rural First Aid Initiative",
    hero_l1: "Empowering",
    hero_strong: "Bystanders",
    hero_l2_post: " to",
    hero_l3: "Save Lives.",
    hero_sub:
      "Free, quality CPR and First Aid Support classes delivered directly to remote, regional, and Indigenous communities. Engineered to bypass geographic and structural bottlenecks to build pure capability and confidence.",
    hero_cta: "[ Request a Training Deployment ]",
    hero_scroll: "Scroll",

    // Manifesto
    man_label: "Our Mandate",
    man_heading: "We treat emergency readiness as infrastructure, not a privilege.",
    man_chapters: [
      {
        n: "01",
        title: "Capability over credentials",
        body: "Every second before EMS arrives is decided by the person already standing there. We build that person, the bystander, into a first responder.",
      },
      {
        n: "02",
        title: "Distance is not destiny",
        body: "Remote, regional and Indigenous communities are furthest from help and closest to risk. We carry the training to them, absorbing the travel and logistics ourselves.",
      },
      {
        n: "03",
        title: "Sustained Impact over Short-Term Presence",
        body: "We trade the standard drop-in model for co-designed partnerships, securing longitudinal support and lasting local self-reliance.",
      },
    ],

    // Logistics
    log_label: "Operational Logistics",
    log_title: "What We Deliver",
    log_boxes: [
      {
        title: "Free First Aid Classes",
        body: "Practical, high-yield instruction focused entirely on immediate, real-world intervention. No cost, no red tape.",
      },
      {
        title: "Tailored to Rural & Remote Regions",
        body: "We eliminate geographic barriers by taking care of our own travel and logistics to reach underserved areas.",
      },
      {
        title: "Co-Designed & Student-Led",
        body: "Built from the ground up by healthcare students collaborating directly with community leaders to meet localized training goals.",
      },
      {
        title: "Pure Lifesaving Capability",
        body: "Stripped of unnecessary institutional filler to maximize hands-on retention, muscle memory, and bystander confidence.",
      },
    ],

    // Topics
    marquee: [
      "BYSTANDER CAPABILITY",
      "MUSCLE MEMORY",
      "RAPID RECALL",
      "COMMUNITY-LED",
      "NO RED TAPE",
      "REGIONAL SELF-RELIANCE",
      "HANDS-ON RETENTION",
    ],
    topics_label: "Modules We Cover",
    topics: [
      "CPR & AED",
      "Drowning",
      "Choking",
      "Anaphylaxis",
      "Naloxone",
      "Stroke",
      "Heart Attack",
      "Bleeding",
      "Asthma Exacerbation",
      "Tick Bites & Stings",
    ],

    // Map
    map_label: "Regional Impact",
    map_title: "Where We've Been",
    map_sub: "Tracking our path across Quebec as we build regional emergency self-reliance.",
    map_pins: {
      manawan: {
        region: "Upper Lanaudière Region",
        note: "Atikamekw community deployment — bystander CPR & bleeding control.",
      },
      ndg: {
        region: "Greater Montreal Area",
        note: "Notre-Dame-de-Grâce cohort — urban first-response readiness.",
      },
    },
    map_more: "More regions incoming. Request a deployment to put your community on the map.",

    // Form
    form_label: "Deployment Request",
    form_title: "Bring Code Echo to Your Community",
    form_sub: "Submit your organizational parameters below to request a mobile training deployment.",
    f_name: "Full Name / Primary Contact",
    f_name_ph: "Jane Doe",
    f_email: "Contact Email",
    f_email_ph: "you@email.com",
    f_org: "Organization / Community Group",
    f_org_ph: "Community Health Council",
    f_location: "Target Location / Region (Quebec)",
    f_location_ph: "e.g. Abitibi-Témiscamingue",
    f_cohort: "Estimated Cohort Size",
    f_cohort_ph: "Select size",
    f_month: "Estimated Month of Training",
    f_month_ph: "e.g. September 2026",
    f_notes: "Additional Logistics or Timing Notes",
    f_notes_ph: "Preferred dates, access, venue, community context…",
    f_submit: "[ Launch Deployment Request ]",
    f_submitting: "Launching…",
    f_err_required: "Please complete all required fields.",
    f_ok_toast: "Deployment request launched. We'll be in touch.",
    f_err_toast: "Something went wrong. Please try again.",
    f_success_title: "Request received.",
    f_success_body:
      "Your deployment request is in the queue. Our student-led team will reach out with next steps.",
    f_reset: "Submit another request",

    // Resource hub
    res_label: "Resource Hub",
    res_title: "Course Design",
    res_sub:
      "Our classes focus on hands-on skills and giving you the confidence to act when it matters most. Download our first aid summary sheet, engineered for rapid recall during critical situations to help bypass the natural freeze response.",
    res_tag: "High-Yield Field Reference",
    res_btn: "[ Download The Summary Sheet ]",
    res_modal_title: "Access the Cheat Sheet",
    res_modal_desc: "Tell us where to send it. Your guide unlocks instantly.",
    res_name: "Name",
    res_name_ph: "Your name",
    res_email: "Email Address",
    res_email_ph: "you@email.com",
    res_check: "I am a community leader / teacher / emergency responder",
    res_submit: "[ Access Cheat Sheet ]",
    res_err_required: "Please enter your name and email.",
    res_err_toast: "Unable to process. Please try again.",
    res_success_title: "Request received.",
    res_success_msg: "We will send it to you shortly. Please keep an eye on your email!",
    join_title: "Join Our Mission",
    join_donate: "Donate",
    join_team: "Join Our Team",
    join_donate_msg: "Please send your contribution to: code.echo.first.aid@gmail.com. Thank you for your valued support!",
    join_insta: "Follow Us on Insta",
    foot_inquiry_prefix: "Have an inquiry? Please contact us at ",
    foot_inquiry_suffix: ".",
    close: "Close",

    // Thank you
    ty_title_named: (n) => `Thank you, ${n}.`,
    ty_title: "You're all set.",
    ty_body:
      "Your Response Guide is downloading now. Keep it close — rapid recall saves lives. If the download didn't start, grab it below.",
    ty_download: "Download the Guide",
    ty_home: "Back to Code Echo",

    // Footer
    foot_disclaimer:
      "Code Echo delivers high-yield, independent emergency readiness classes focused on rapid bystander capability. Our community-centered programming operates outside of standard institutional licensing frameworks to maximize regional outreach.",
    foot_instagram: "Follow @code.echo_first.aid",
    copyright: "© 2026 Code Echo Initiative. All rights reserved.",
  },

  fr: {
    nav_links: [
      { label: "Notre Mandat", id: "manifesto" },
      { label: "Ce Que Nous Offrons", id: "logistics" },
      { label: "Où Nous Sommes Allés", id: "map" },
      { label: "Rejoignez Notre Mission", id: "join" },
    ],
    nav_cta: "Faire une demande de formation",

    hero_badge: "Initiative Rurale de Premiers Soins à But Non Lucratif",
    hero_l1: "Habiliter les",
    hero_strong: "Témoins",
    hero_l2_post: " à",
    hero_l3: "Sauver des Vies.",
    hero_sub:
      "Des cours gratuits et de qualité de RCR et de premiers soins, offerts directement aux communautés éloignées, régionales et autochtones. Conçus pour contourner les obstacles géographiques et structurels afin de bâtir des compétences et une confiance véritables.",
    hero_cta: "[ Demander un Déploiement de Formation ]",
    hero_scroll: "Défiler",

    man_label: "Notre Mandat",
    man_heading:
      "Nous considérons la préparation aux urgences comme une infrastructure, pas un privilège.",
    man_chapters: [
      {
        n: "01",
        title: "La compétence avant les diplômes",
        body: "Chaque seconde avant l'arrivée des secours est déterminée par la personne déjà sur place. Nous transformons cette personne, le témoin, en premier intervenant.",
      },
      {
        n: "02",
        title: "La distance n'est pas une fatalité",
        body: "Les communautés éloignées, régionales et autochtones sont les plus loin des secours et les plus exposées aux risques. Nous leur apportons la formation en prenant en charge les déplacements et la logistique.",
      },
      {
        n: "03",
        title: "Un impact durable plutôt qu'une présence ponctuelle",
        body: "Nous remplaçons le modèle ponctuel habituel par des partenariats co-conçus, assurant un soutien à long terme et une autonomie locale durable.",
      },
    ],

    log_label: "Logistique Opérationnelle",
    log_title: "Ce Que Nous Offrons",
    log_boxes: [
      {
        title: "Cours de Premiers Soins Gratuits",
        body: "Une formation pratique et à haut rendement, entièrement axée sur l'intervention immédiate et concrète. Sans frais, sans paperasse.",
      },
      {
        title: "Adapté aux Régions Rurales et Éloignées",
        body: "Nous éliminons les barrières géographiques en prenant en charge nos propres déplacements et notre logistique pour atteindre les régions mal desservies.",
      },
      {
        title: "Co-Conçu et Dirigé par des Étudiants",
        body: "Conçu de A à Z par des étudiants en santé collaborant directement avec les leaders communautaires pour répondre à des objectifs de formation locaux.",
      },
      {
        title: "Une Capacité de Sauvetage Pure",
        body: "Débarrassé du superflu institutionnel pour maximiser la rétention pratique, la mémoire musculaire et la confiance des témoins.",
      },
    ],

    marquee: [
      "CAPACITÉ DES TÉMOINS",
      "MÉMOIRE MUSCULAIRE",
      "RAPPEL RAPIDE",
      "MENÉ PAR LA COMMUNAUTÉ",
      "SANS PAPERASSE",
      "AUTONOMIE RÉGIONALE",
      "RÉTENTION PRATIQUE",
    ],
    topics_label: "Modules Que Nous Couvrons",
    topics: [
      "RCR et DEA",
      "Noyade",
      "Étouffement",
      "Anaphylaxie",
      "Naloxone",
      "AVC",
      "Crise Cardiaque",
      "Hémorragie",
      "Crise d'Asthme",
      "Morsures de Tiques et Piqûres",
    ],

    map_label: "Impact Régional",
    map_title: "Où Nous Sommes Allés",
    map_sub:
      "Nous suivons notre parcours à travers le Québec en bâtissant l'autonomie régionale en cas d'urgence.",
    map_pins: {
      manawan: {
        region: "Région de la Haute-Lanaudière",
        note: "Déploiement dans la communauté atikamekw — RCR par les témoins et contrôle des hémorragies.",
      },
      ndg: {
        region: "Grand Montréal",
        note: "Cohorte de Notre-Dame-de-Grâce — préparation à la première intervention en milieu urbain.",
      },
    },
    map_more:
      "D'autres régions à venir. Demandez un déploiement pour inscrire votre communauté sur la carte.",

    form_label: "Demande de Déploiement",
    form_title: "Amenez Code Echo dans Votre Communauté",
    form_sub:
      "Soumettez les paramètres de votre organisation ci-dessous pour demander un déploiement de formation mobile.",
    f_name: "Nom Complet / Personne-Ressource",
    f_name_ph: "Jean Tremblay",
    f_email: "Courriel de Contact",
    f_email_ph: "vous@courriel.com",
    f_org: "Organisation / Groupe Communautaire",
    f_org_ph: "Conseil de Santé Communautaire",
    f_location: "Lieu / Région Ciblée (Québec)",
    f_location_ph: "p. ex. Abitibi-Témiscamingue",
    f_cohort: "Taille Estimée du Groupe",
    f_cohort_ph: "Choisir une taille",
    f_month: "Mois de Formation Estimé",
    f_month_ph: "p. ex. septembre 2026",
    f_notes: "Notes Supplémentaires sur la Logistique ou le Calendrier",
    f_notes_ph: "Dates préférées, accès, lieu, contexte communautaire…",
    f_submit: "[ Lancer la Demande de Déploiement ]",
    f_submitting: "Envoi en cours…",
    f_err_required: "Veuillez remplir tous les champs obligatoires.",
    f_ok_toast: "Demande de déploiement lancée. Nous vous contacterons.",
    f_err_toast: "Une erreur s'est produite. Veuillez réessayer.",
    f_success_title: "Demande reçue.",
    f_success_body:
      "Votre demande de déploiement est en file d'attente. Notre équipe étudiante vous contactera pour la suite.",
    f_reset: "Soumettre une autre demande",

    res_label: "Centre de Ressources",
    res_title: "Conception du cours",
    res_sub:
      "Nos cours mettent l'accent sur la pratique et vous donnent la confiance nécessaire pour agir quand cela compte le plus. Téléchargez notre fiche récapitulative de premiers secours, conçue pour un rappel rapide en situation critique afin de vous aider à surmonter la réaction naturelle de paralysie.",
    res_tag: "Référence de Terrain à Haut Rendement",
    res_btn: "[ Télécharger la fiche récapitulative ]",
    res_modal_title: "Accéder à l'Aide-Mémoire",
    res_modal_desc: "Dites-nous où l'envoyer. Votre guide se débloque instantanément.",
    res_name: "Nom",
    res_name_ph: "Votre nom",
    res_email: "Adresse Courriel",
    res_email_ph: "vous@courriel.com",
    res_check: "Je suis un leader communautaire / enseignant / intervenant d'urgence",
    res_submit: "[ Accéder à l'Aide-Mémoire ]",
    res_err_required: "Veuillez saisir votre nom et votre courriel.",
    res_err_toast: "Traitement impossible. Veuillez réessayer.",
    res_success_title: "Demande reçue.",
    res_success_msg: "Nous vous l'enverrons sous peu. Veuillez svp garder un œil sur votre courriel!",
    join_title: "Rejoignez Notre Mission",
    join_donate: "Faire un don",
    join_team: "Rejoindre notre équipe",
    join_donate_msg: "Veuillez envoyer votre contribution à : code.echo.first.aid@gmail.com. Merci pour votre soutien précieux!",
    join_insta: "Suivez-nous sur Insta",
    foot_inquiry_prefix: "Avez-vous une question\u00a0? Veuillez nous contacter à ",
    foot_inquiry_suffix: ".",
    close: "Fermer",

    ty_title_named: (n) => `Merci, ${n}.`,
    ty_title: "Tout est prêt.",
    ty_body:
      "Votre Guide d'Intervention se télécharge maintenant. Gardez-le à portée de main — un rappel rapide sauve des vies. Si le téléchargement n'a pas démarré, récupérez-le ci-dessous.",
    ty_download: "Télécharger le Guide",
    ty_home: "Retour à Code Echo",

    foot_disclaimer:
      "Code Echo offre des cours de préparation aux urgences indépendants et à haut rendement, axés sur la capacité d'intervention rapide des témoins. Notre programmation communautaire fonctionne en dehors des cadres d'accréditation institutionnels standards afin de maximiser la portée régionale.",
    foot_instagram: "Suivez @code.echo_first.aid",
    copyright: "© 2026 Initiative Code Echo. Tous droits réservés.",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("codeecho_lang") || "en";
    }
    return "en";
  });

  useEffect(() => {
    localStorage.setItem("codeecho_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = {
    lang,
    setLang,
    toggle: () => setLang((l) => (l === "en" ? "fr" : "en")),
    t: TRANSLATIONS[lang],
    logo: LOGOS[lang],
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
